import { NgModule } from '@angular/core';
import { TriggerDuplicateDirective } from './trigger-duplicate.directive';

@NgModule({
  imports: [],
  exports: [TriggerDuplicateDirective],
  declarations: [TriggerDuplicateDirective],
  providers: []
})
export class TriggerDuplicateModule {}
